import React from 'react';
import { useNavigate } from "react-router-dom";
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useAdminAuth } from "../../context/AdminAuthContext";

import {
  FaHome,
  FaClipboardList,
  FaChartPie,
  FaUserCircle,
  FaTools,
  FaSignOutAlt
} from "react-icons/fa";

const Sidebar = () => {
  const location = useLocation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const { adminLogout } = useAdminAuth();
  
  const handleLogout = () => {
    adminLogout();
    navigate("/admin-23nafs-33/login");
  };

const navigation = [
  { name: 'الاحصائيات', href: '/admin-23nafs-33/dashboard', icon: <FaHome size={20} /> },
  { name: 'الاختبارات', href: '/admin-23nafs-33/dashboard/tests', icon: <FaClipboardList size={20} /> },
  { name: 'الفصول', href: '/admin-23nafs-33/dashboard/results', icon: <FaChartPie size={20} /> },
  { name: 'إدارة التعليقات', href: '/admin-23nafs-33/dashboard/profile', icon: <FaUserCircle size={20} /> },
  { name: 'الإعدادات & الاحصائيات', href: '/admin-23nafs-33/dashboard/settings', icon: <FaTools size={20} /> },
];


  return (
    <div dir="rtl" className="flex flex-col w-64 bg-white border-l border-gray-200 shadow-md">

       <div className="flex items-center justify-center h-20 border-b border-gray-200">
        <h1 className="text-2xl font-bold text-blue-600">نافس</h1>
      </div>

       <nav className="flex-1 px-4 py-5 space-y-2">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href;

          return (
            <Link
              key={item.name}
              to={item.href}
              className={`
                flex items-center gap-4 px-4 py-3 rounded-lg text-sm font-medium transition-all
                ${isActive 
                  ? "bg-blue-50 text-blue-700 border-l-4 border-blue-600"
                  : "text-gray-700 hover:bg-gray-100"
                }
              `}
            >
              <span className={`text-xl ${isActive ? "text-blue-700" : "text-gray-500"}`}>
                {item.icon}
              </span>
              <span className="text-base">{item.name}</span>
            </Link>
          );
        })}
      </nav>

       <div className="px-4 py-6 border-t border-gray-200">
        <button
          onClick={handleLogout}
          className="flex items-center gap-4 w-full px-4 py-3 text-base font-medium text-gray-700 rounded-lg hover:bg-red-50 hover:text-red-600 transition-all"
        >
          <FaSignOutAlt size={20} />
          <span>تسجيل الخروج</span>
        </button>
      </div>

    </div>
  );
};

export default Sidebar;
